<template>
  <v-dialog :value="dialog" max-width="60%" persistent>
    <v-card>
      <v-card-title class="headline accent--text pb-4">
        {{ isEdit ? 'Редактировать' : 'Создать' }}
      </v-card-title>

      <v-card-text outlined tile class="border-top pt-6 pb-0">
        <v-row>
          <v-col cols="12" class="pb-0">
            <v-autocomplete
              v-model="vacancy.speciality"
              :items="dictionaries.speciality"
              auto-select-first
              item-text="name"
              label="Специальность"
              placeholder="Выберите из списка"
              rounded
              outlined
              dense
              return-object
              @input="$v.vacancy.speciality.$touch()"
              @blur="$v.vacancy.speciality.$touch()"
              :error-messages="errorMessages.speciality"
            />
          </v-col>

          <v-col cols="12" class="py-0">
            <v-autocomplete
              v-model="vacancy.courseNumber"
              :items="dictionaries.courseNumber"
              auto-select-first
              item-text="name"
              label="Номер курса"
              placeholder="Выберите из списка"
              rounded
              outlined
              dense
              return-object
              @input="$v.vacancy.courseNumber.$touch()"
              @blur="$v.vacancy.courseNumber.$touch()"
              :error-messages="errorMessages.courseNumber"
            />
          </v-col>

          <v-col cols="12" class="py-0">
            <v-autocomplete
              v-model="vacancy.paidForm"
              :items="dictionaries.paidForm"
              auto-select-first
              item-text="name"
              label="Тип обучения"
              placeholder="Выберите из списка"
              rounded
              outlined
              dense
              return-object
              @input="$v.vacancy.paidForm.$touch()"
              @blur="$v.vacancy.paidForm.$touch()"
              :error-messages="errorMessages.paidForm"
            />
          </v-col>

          <v-col cols="12" class="py-0">
            <v-text-field
              v-model="vacancy.quantity"
              label="Мест"
              placeholder="Введите место"
              rounded
              outlined
              dense
              v-mask="'####'"
              @change="$v.vacancy.quantity.$touch()"
              @blur="$v.vacancy.quantity.$touch()"
              :error-messages="errorMessages.quantity"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-6">
        <v-spacer></v-spacer>
        <v-btn text color="lightGrey" @click="closeModal">Закрыть</v-btn>
        <v-btn
          :loading="saveBtnLoading"
          :disabled="$v.$invalid"
          color="success"
          text
          @click="saveVacancy"
        >
          {{ isEdit ? 'Редактировать' : 'Создать' }}
        </v-btn>
      </v-card-actions>
  </v-card>
  </v-dialog>
</template>

<script>
import { Vacancy } from '@/models'
import { required, maxLength, email } from 'vuelidate/lib/validators'
import { setValidateMessages } from '@/scripts/validation'
import {mapGetters} from "vuex";

export default {
  name: 'Vacancy',

  props: {
    dialog: Boolean,
    selectedItem: Vacancy,
    saveBtnLoading: Boolean,
  },

  data() {
    return {
      vacancy: new Vacancy(),
    }
  },

  validations() {
    return {
      vacancy: {
        speciality: { required },
        quantity: { required },
        paidForm: { required },
        courseNumber: { required }
      }
    }
  },

  computed: {
    ...mapGetters('dictionaries', ['dictionaries']),

    isEdit() {
      return this.selectedItem?.id
    },

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.vacancy.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.vacancy[key])
      })
      return allErrors
    },
  },

  methods: {
    async saveVacancy() {
      this.$emit('saveVacancy', this.vacancy)
    },

    resetModal() {
      this.$v.$reset()
      this.vacancy = new Vacancy()
    },

    closeModal() {
      this.resetModal()
      this.$emit('closeModal')
    },
  },

  watch: {
    async selectedItem(val) {
      this.vacancy = val ? Vacancy.build(val) : new Vacancy()
    },

    dialog(val) {
      !val && this.resetModal()
    }
  }
}
</script>
<style scoped>
  .border-top {
    border: 0 !important;
    border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
  }

  .theme--light.v-btn.v-btn--disabled {
    color: #dadada !important
  }
</style>
